<template>
  <div
    class="align-center background-color-white d-flex flex-column pb-5 pt-10 px-7"
  >
    <div class="font-size-lg font-weight-semibold text-center">
      Welcome to {{ wait(storeInfo, "name") }}
    </div>
    <div class="mb-5">Select a login option</div>
    <v-btn
      class="mb-8"
      color="accent"
      @click="toLogInRoute($options.Views.email)"
      block
      large
      rounded
    >
      <v-icon class="mr-3" small>mdi-email-outline</v-icon>
      <div class="font-size-md font-weight-semibold text-none">
        Log in with Email
      </div>
    </v-btn>
    <v-btn
      color="accent"
      @click="toLogInRoute($options.Views.phone)"
      block
      large
      rounded
    >
      <v-icon class="mr-3" small>mdi-phone-message-outline</v-icon>
      <div class="font-size-md font-weight-semibold text-none">
        Log in with Phone Number
      </div>
    </v-btn>
    <OrDivider />
    <v-btn
      class="mb-4"
      color="primary"
      @click="toAuthRoute('signup')"
      block
      large
      rounded
    >
      <div class="font-size-md font-weight-semibold text-capitalize">
        sign up
      </div>
    </v-btn>
    <button class="mb-4" @click="toAuthRoute('request')">
      Forgot your password?
      <span class="font-weight-semibold outline-none primary--text"
        >Reset it</span
      >.
    </button>
    <div
      class="color-suva-grey font-weight-semibold text-center"
      :class="$vuetify.breakpoint.xsOnly ? 'font-size-xxs' : 'font-size-sm'"
    >
      By tapping the Log In or Sign Up buttons you agree to our:
    </div>
    <LegalLinks :closeAuth="closeAuth" />
  </div>
</template>

<script>
import { Views } from "@/types/login.js";
import { mapState } from "vuex";
import { wait } from "@/util.js";
import LegalLinks from "@/components/Auth/LogIn/LegalLinks.vue";
import OrDivider from "@/components/Auth/LogIn/OrDivider.vue";

export default {
  name: "LogInOptionsContent",
  components: {
    LegalLinks,
    OrDivider,
  },
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  data() {
    return {
      email: null,
      password: null,
      valid: true,
    };
  },
  methods: {
    wait,
  },
  props: {
    closeAuth: Function,
    toAuthRoute: Function,
    toLogInRoute: Function,
  },
  Views,
};
</script>
